export function Spinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div role="status" className="flex items-center gap-2 p-4 text-sm text-muted">
      <SpinnerIcon />
      {label}
    </div>
  );
}

export function SpinnerIcon() {
  return (
    <span
      aria-hidden
      className="inline-block size-4 rounded-full border-2 border-line-strong border-t-accent motion-safe:animate-spin"
    />
  );
}
